import { Cover } from "@components/anti/Cover"
import { translations } from "src/helper/translations"
import { imgUrl } from "src/mixins"

function ServicesStarNow({ data, locale, tab }) {
  return (
    <Cover
      title={data && data[`title_${locale}`]}
      titleClassName="h2 mb-4"
      className="sc-services-book"
      text=""
      img={imgUrl(data?.banner_image_mobile)}
      imgHeight="h-500px"
      imgMd={imgUrl(data?.banner_image_desktop)}
      buttons={[
        {
          text: tab === "studio-booking" ? "Whatsapp" : "Email",
          link: { url: data?.whatsapp_url },
          target: "_blank",
        },
      ]}
    />
  )
}

export default ServicesStarNow
